import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Integrations from 'components/Integrations'
import { CustomWebhooksLoader } from 'router/Loaders/CustomWebhooksLoader'

export const IntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <CustomWebhooksLoader isParentLoaded={isParentLoaded}>
          {(isLoaded) => (
            <LoaderSwitcher isParentLoaded={isLoaded}>
              <Integrations />
            </LoaderSwitcher>
          )}
        </CustomWebhooksLoader>
      )}
    </MerchantLocationsLoader>
  )
}
